/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAppAction } from "../appAction";
import { applicationActions } from "./application-action";
import { authModalTabs, getDefaultApplicationState, IApplicationState } from "./application-state";
import { setGIFSound, setGIFQuality } from "utils/storage";

const handlers = {
  [applicationActions.TOGGLE_BURGER_MENU]: (
    state: IApplicationState,
  ): IApplicationState => {
    return {
      ...state,
      isBurgerMenuOpen: !state.isBurgerMenuOpen,
      isProfileMenuOpen: false,
      isSearchBarOpen: false,
    };
  },
  [applicationActions.TOGGLE_PROFILE_MENU]: (
    state:IApplicationState,
  ): IApplicationState => {
    return {
      ...state,
      isProfileMenuOpen: !state.isProfileMenuOpen,
      isSearchBarOpen: false,
      isBurgerMenuOpen: false,
    };
  },
  [applicationActions.TOGGLE_SEARCH_BAR]: (
    state: IApplicationState,
  ): IApplicationState => {
    return {
      ...state,
      isSearchBarOpen: !state.isSearchBarOpen,
      isBurgerMenuOpen: false,
      isProfileMenuOpen: false,
    };
  },
  [applicationActions.HIDE_ALL_MENUS]: (
    state: IApplicationState
  ): IApplicationState => {
    return {
      ...state,
      isSearchBarOpen: false,
      isBurgerMenuOpen: false,
      isProfileMenuOpen: false,
    };
  },
  [applicationActions.SET_GIF_QUALITY]: (
    state: IApplicationState, payload: string
  ): IApplicationState => {
    setGIFQuality(payload);

    return {
      ...state,
      gifQuality: payload
    };
  },
  [applicationActions.TOGGLE_GIF_SOUND]: (
    state: IApplicationState,
    payload: any
  ): IApplicationState => {
    setGIFSound(JSON.stringify(payload));

    return {
      ...state,
      gifSound: payload
    };
  },
  [applicationActions.SET_SERVER_RESPONSE]: (state: IApplicationState, payload: any): IApplicationState => {
    return {
      ...state,
      serverResponse: payload
    };
  },
  [applicationActions.SET_SERVER_ERROR]: (state: IApplicationState, payload: any): IApplicationState => {
    return {
      ...state,
      serverError: payload
    };
  },
  [applicationActions.SHOW_AUTH_MODAL]: (
    state: IApplicationState,
    { tab }: { tab: authModalTabs }
  ): IApplicationState => {
    return {
      ...state,
      authModal: {
        show: true,
        tab,
      }
    };
  },
  [applicationActions.HIDE_AUTH_MODAL]: (
    state: IApplicationState,
  ): IApplicationState => {
    return {
      ...state,
      authModal: {
        ...state.authModal,
        show: false
      }
    };
  },
  [applicationActions.TOGGLE_FULLSCREEN]: (
    state: IApplicationState,
    payload: any
  ): IApplicationState => {
    return {
      ...state,
      isFullScreen: payload
    };
  },
};

export const applicationReducer = (
  state: IApplicationState = getDefaultApplicationState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) :
    state;
};
